import React from 'react';
import styled from '@emotion/styled';
import IconArrowSelect from '../icon/IconArrowSelect';
import Span from '../text/Span';
import { GRAY } from '../../../styles/constants/color';
import Input from '../input/Input';
import { flexFrame } from '../../../styles/mixin/figure';

const Base = styled.div<{ isInput: boolean }>`
  ${flexFrame('', 'end', 'center')}
  // width: 80px;
  width: auto;
  height: 25px;
  border-bottom: ${props => !props.isInput && `1px solid ${GRAY}`};
  cursor: pointer;

  & > input + span {
    margin-left: 8px;
  }

  & > *:last-of-type {
    margin-left: 8px;
  }

  & .arrow-wrapper svg {
    transition: all 0.3s ease-in-out;
  }

  &:hover .arrow-wrapper svg {
    transform: rotate(90deg);
  }
`;

interface Props {
  value: string | number;
  unit?: string;
  isInput?: boolean;
  inputName?: string;
  inputType?: string;
  inputValue?: string | number;
  onClick: () => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

/**
 *  커스텀 셀렉트 컴포넌트. 직접 입력일 때의 input도 나타낸다.
 * @param {string} value 커스텀 셀렉트에 연결된 상태의 state
 * @param {string?} unit 직접입력시 input 태그 옆에 나올 단위
 * @param {boolean} isInput 직접입력인지에 대한 여부 (default: false)
 * @param {string} inputName 직접입력 input의 name (default: '')
 * @param {string} inputType 직접입력 input의 type (default: text)
 * @param {string | number} inputValue 직접입력 input의 value (default: '선택')
 * @param {function} onClick 커스텀 셀렉트 onClick 이벤트
 * @param {function} onChange 직접입력의 onChange 이벤트
 *  */
function CustomSelect({
  value = '선택',
  unit,
  isInput,
  inputName = '',
  inputType = 'text',
  inputValue,
  onClick,
  onChange,
}: Props): JSX.Element {
  return (
    <Base isInput={isInput || false} onClick={onClick}>
      {isInput && onChange ? (
        <>
          <Input type={inputType} name={inputName} onChange={onChange} value={inputValue || ''} />
          {unit && <Span>{unit}</Span>}
        </>
      ) : (
        <Span>{value}</Span>
      )}
      <IconArrowSelect />
    </Base>
  );
}

export default CustomSelect;
